export default __webpack_public_path__ + "static/media/glorificationofset.9b768b4c.png";